import React from 'react';

// Chrome shared by the anonymous link pages (/s, /t, /r). These render for
// visitors with no session and no theme preference stored, so they deliberately
// use fixed light colours rather than the app's CSS variables.
export default function PublicShell({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f6fa', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ marginBottom: 32, display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 32, height: 32, borderRadius: 8, background: '#2d5cf6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ color: 'white', fontSize: 16, fontWeight: 700 }}>S</span>
        </div>
        <span style={{ fontWeight: 700, fontSize: 18, color: '#1a1a2e' }}>SK Drive</span>
      </div>
      {children}
    </div>
  );
}

export function PublicCard({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) {
  return (
    <div style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 16, padding: 28, maxWidth: 540, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', ...style }}>
      {children}
    </div>
  );
}

export function PublicError({ title, message }: { title: string; message: string }) {
  return (
    <div style={{ textAlign: 'center', maxWidth: 360 }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>🔗</div>
      <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 8, color: '#1a1a2e' }}>{title}</div>
      <div style={{ color: '#6b7280', fontSize: 14, lineHeight: 1.6 }}>{message}</div>
    </div>
  );
}

// Password gate for links created with one. `error` is set after a failed attempt.
export function PublicPasswordGate({ label, value, onChange, onSubmit, busy, error }: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  busy?: boolean;
  error?: string;
}) {
  return (
    <PublicCard style={{ maxWidth: 400 }}>
      <div style={{ textAlign: 'center', marginBottom: 18 }}>
        <div style={{ fontSize: 34, marginBottom: 8 }}>🔒</div>
        <div style={{ fontWeight: 700, fontSize: 18, color: '#1a1a2e' }}>{label}</div>
        <div style={{ color: '#6b7280', fontSize: 13, marginTop: 6 }}>
          Ask the sender for the password if you don't have it.
        </div>
      </div>
      <form
        onSubmit={e => { e.preventDefault(); onSubmit(); }}
        style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
      >
        <input
          type="password"
          autoFocus
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="Password"
          style={{ padding: '10px 12px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14, width: '100%' }}
        />
        {error && <div style={{ color: '#dc2626', fontSize: 13 }}>{error}</div>}
        <button
          type="submit"
          disabled={busy || value.length === 0}
          style={{ padding: '10px 12px', borderRadius: 8, border: 'none', background: value.length === 0 || busy ? '#9ca3af' : '#2d5cf6', color: 'white', fontSize: 14, fontWeight: 600, cursor: value.length === 0 || busy ? 'default' : 'pointer' }}
        >
          {busy ? 'Checking…' : 'Unlock'}
        </button>
      </form>
    </PublicCard>
  );
}
